import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Agencies } from 'app/models/agencies';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { SearchService } from 'app/services/search/search.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-promoteurs-jerba',
  templateUrl: './promoteurs-jerba.component.html',
  styleUrls: ['./promoteurs-jerba.component.scss']
})
export class PromoteursJerbaComponent implements OnInit {

  public AgenciesDjerba: any
  public lengthBoutique:any
  public testArraySort: any
  responsiveOptions

  @ViewChild('agencyForm', { static: false })
  agencyForm: NgForm;
  p: Number = 1;

  agenciedData: Agencies;
  dataSource = new MatTableDataSource();
  displayedColumns: string[];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  isEditMode = false;
  public agencies:any
  search_name1:any;
  public idAgency: any
  public Agency: any
  public search: string  = ''
  pageIndex:number = 0;
  pageSize:number = 50;
  lowValue:number = 0;
  highValue:number = 50; 
  lengthSociete=10;
  totalSociete : any;
  arrays: any[] = [];
  tempArray: any[] = [];
  newArray: any[] = []
  errorMessage: string;

  constructor(private agencieService: AgenciesService,
    private searchService: SearchService) { }

  ngOnInit(): void {
    this.getAgencesDjerba();
  }
  getAgencesDjerba() {
    this.agencieService.getAgencieDjerba().subscribe(
      (data: any) => {
        this.AgenciesDjerba = data;
        console.log("Liste des agences en Djerba", this.AgenciesDjerba);
  
        // Filtrer les promoteurs de Djerba
        this.agencies = this.AgenciesDjerba
          .sort((a: any, b: any) => {
            // Sort based on the existence of projets array
            if (a.projets.length === 0 && b.projets.length > 0) {
              return 1; // Move agency with empty projets to the end
            } else if (a.projets.length > 0 && b.projets.length === 0) {
              return -1; // Move agency with non-empty projets to the beginning
            } else {
              return 0; // No change in order
            }
          });
      },
      (error: any) => {
        // Handle the error here
        console.error("An error occurred:", error);
        this.errorMessage ="Pas de promoteurs avec cette region ! ! !";
      }
    );
  }
  



cancelEdit() {
  this.isEditMode = false;
  this.agencyForm.resetForm();
}

deleteAgencies(agencie,i) {
  Swal.fire({
    title: "Êtes-vous sûr(e) ?",
    text: "Vous ne pourrez pas revenir en arrière !",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Oui, supprimez-le."
  }).then((result) => {
    if (result.isConfirmed) {
      this.agencieService.deleteItem(agencie.id).subscribe((response: any) => {
        console.log(this.dataSource.data);
        // this.AgenciesTunis.splice(i,1)

        // If you want to show a success message after the deletion, use another Swal.fire here
        Swal.fire({
          title: "Supprimé!",
          text: "Votre agence a été supprimée.",
          icon: "success"
        });
        // Fetch the updated data after deletion
       
      }); setTimeout(() => {
          this.getAgencesDjerba();
        }, 500);
      
    }
  });
}
public changePage(){
  this.lengthSociete=this.lengthSociete+10;
}

// Méthode pour effectuer la recherche
performSearch() {
  this.AgenciesDjerba = this.searchService.search(this.AgenciesDjerba, this.search);
}
}